import User from '../Entities/User.js';

function AdminService (apiInstance)
{
	const api = apiInstance; 

	this.inviteUser = (firstname, lastname, email) => {
		return api.request('POST', { firstname: firstname, lastname: lastname, email: email }, 'admin/users/invite', {})
			.then(function (response) {
				let user = new User(response.data.data.user);
				user.created_at = null;
				return user;
			})
			.catch(function (error) {
				throw error;
			});
	}

	this.resetCachedTokens = () => {
		sessionStorage.removeItem("tokens");
	}

	this.listTokens = () => {
		return new Promise(function (resolve, reject) {
			let tokens = sessionStorage.getItem('tokens');
			if (tokens) {
				return resolve(JSON.parse(tokens));
			}

			const fetched = fetchTokensFromServer();
			fetched.then(function (response) {
				tokens = response;
				sessionStorage.setItem('tokens', JSON.stringify(response));
				resolve(tokens);
			});
		});
	}

	function fetchTokensFromServer() {
		return api.request('GET', {}, 'admin/tokens', {}, {})
			.then(function (response) {
				return response.data.data.tokens;
			});
	}

	return this;
}

export default AdminService;


// WEBPACK FOOTER //
// ./src/Services/AdminService.js